<!-- 手工创建 -->
<template>
  <div>
    <!-- <div class="header-title">采购计划详情</div> -->
    <div class="container">
      <!-- 表单 -->
      <div class="commodity-list">
        <div class="title">基本信息</div>
        <el-form
          ref="form"
          style="padding: 12px 0"
          label-width="120px"
          :model="formData"
          @submit.native.prevent
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="采购计划编号：">{{
                formData.purchasePlanCode
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="采购计划名称：">{{
                formData.purchasePlanName
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="概算金额：">{{
                formData.budgetaryTotalAmount !== 0
                  ? `${formData.budgetaryTotalAmount} 元`
                  : '--'
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品批号：">{{
                formData.productBatchNumber
              }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <!-- form-table -->
    <div class="container">
      <div class="commodity-list">
        <div class="title">物料信息</div>
        <el-table
          :data="tableData"
          v-bind="bindMaxHeight()"
          :header-cell-class-name="'verify'"
          border
          style="width: 100%"
        >
          <el-table-column
            type="index"
            width="50"
            align="center"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="categoryName"
            min-width="180"
            align="center"
            label="物料分类"
          ></el-table-column>
          <el-table-column
            prop="categoryCustomCode"
            width="180"
            align="center"
            label="物料编码"
          ></el-table-column>
          <el-table-column
            align="center"
            min-width="300"
            prop="categoryDesc"
            label="物料描述"
          ></el-table-column>
          <el-table-column
            prop="baseUnitName"
            min-width="130"
            align="center"
            label="计量单位"
          ></el-table-column>
          <el-table-column
            prop="specifications"
            min-width="180"
            align="center"
            label="规格型号"
          ></el-table-column>
          <el-table-column
            prop="quantity"
            min-width="130"
            align="center"
            label="采购数量"
          ></el-table-column>
          <el-table-column
            prop="budgetaryPrice"
            min-width="130"
            align="center"
            label="概算单价（元）"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.budgetaryPrice === 0 ? '' : scope.row.budgetaryPrice
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="expectedArrivalDate"
            min-width="160"
            align="center"
            label="计划到货日期"
          ></el-table-column>
          <el-table-column
            prop="imageNumber"
            min-width="130"
            align="center"
            label="图号"
          ></el-table-column>
          <el-table-column
            prop="buyer"
            min-width="130"
            align="center"
            label="订货方"
          ></el-table-column>
          <el-table-column
            prop="partNumber"
            min-width="130"
            align="center"
            label="件号"
          ></el-table-column>
          <el-table-column
            prop="standard"
            min-width="130"
            align="center"
            label="标准"
          ></el-table-column>
          <el-table-column
            prop="remark"
            min-width="130"
            align="center"
            label="备注"
          ></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <eui-btn
                v-if="handleLook(scope.row)"
                type="text"
                @click="queryPurchaseDemandPlanItem(scope.row)"
              >
                查看
              </eui-btn>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="container">
      <!-- 采购计划 -->
      <div class="commodity-list">
        <div class="title">采购计划</div>
        <el-form
          ref="formPurchaseType"
          style="margin: 20px 0"
          inline
          label-width="120px"
          @submit.native.prevent
        >
          <el-form-item label="采购计划：">
            {{ purchaseTypeList[formData.purchaseModeType - 1] }}
          </el-form-item>
          <el-form-item label="框架协议：">
            {{ formData.protocolCode }}
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="container">
      <!-- 备注附件 -->
      <div class="commodity-list">
        <div class="title">备注附件</div>
        <el-form
          ref="formPurchaseType"
          style="margin: 20px 0"
          label-width="100px"
          @submit.native.prevent
        >
          <el-form-item label="附件：">
            <div>
              <span
                v-for="item of formData.purchasePlanAttachmentVOList"
                :key="item.fileUrl"
                class="file-name"
                @click="handleExportDatail2(item)"
              >
                {{ dealAttachmentName(item.attachmentName) }}
              </span>
            </div>
          </el-form-item>
          <el-form-item label="备注：">{{ formData.remark }}</el-form-item>
        </el-form>
      </div>
    </div>

    <div
      v-if="approvalData.length > 0"
      class="container"
      style="overflow: hidden; padding-bottom: 20px; padding-top: 0"
    >
      <!-- 审批流组件-->
      <approval-process :approval-data="approvalData" />
    </div>

    <!-- 保存 -->
    <div class="submit-box">
      <eui-btn type="secondary" @click="handleGoBack">返回</eui-btn>
    </div>
    <!-- 查看 -->
    <e-dialog
      :dialog-title="'物料汇总清单'"
      :center-dialog-visible="visible"
      :popup-width="'800px'"
      :is-show-cancel="false"
      @submitPopupData="resetPopupData"
      @resetPopupData="resetPopupData"
    >
      <e-table-list
        style="margin-top: 20px"
        :table-data="detailTableData"
        :table-label="detailTableLabel"
        :index-show="true"
      >
        <template #code="tData">
          <el-link
            :underline="false"
            type="primary"
            @click="handleCodeDetail(tData.scope.row)"
          >
            {{ tData.scope.row.purchaseDemandCode }}
          </el-link>
        </template>
        <template #company="tData">
          <el-link
            :underline="false"
            type="primary"
            @click="handleExportDatail(tData.scope.row)"
          >
            {{ getAttachmentName(tData.scope.row) }}
          </el-link>
        </template>
      </e-table-list>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import utils, { dealAttachmentName } from '@/modules/projectA/utils/utils';
import approvalProcess from '@/modules/projectA/components/common/approvalProcess.vue';
import stepUtils from '@/modules/projectA/utils/stepUtils';
import Api from '@/modules/projectA/api/purchase';
import enApi from '@/modules/projectA/api/enquiry';
import FileUpload from '../components/fileUpload.vue';

export default {
  components: {
    eDialog,
    eTableList,
    FileUpload,
    approvalProcess,
  },
  data() {
    return {
      approvalData: [],
      visible: false,
      routeData: null,
      // 选择审批流程
      tipsMessage: '支持excel、pdf、wrod 格式文件，小于30M',
      uploadUrl: '',
      queryData: {
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      detailTableData: [],
      detailTableLabel: [
        {
          label: '采购需求编号',
          align: 'center',
          slot: 'code',
          fixed: 'left',
          minWidth: '170',
        },
        {
          label: '采购需求名称',
          param: 'purchaseDemandName',
          align: 'center',
          fixed: 'left',
          minWidth: '170',
        },
        {
          label: '需求数量',
          param: 'quantity',
          align: 'center',
          minWidth: '130',
        },
        {
          label: '需求部门',
          param: 'orgShortName',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '需求申请人',
          param: 'createMemberName',
          align: 'center',
          minWidth: '130',
        },
        {
          label: '期望到货日期',
          param: 'expectedArrivalDate',
          align: 'center',
          minWidth: '130',
        },
        {
          label: '附件',
          fixed: 'right',
          align: 'center',
          slot: 'company',
          minWidth: '140',
        },
      ],
      maxHeight: '400',
      formData: {},
      tableData: [],
      purchaseTypeList: [
        '选品下单',
        '询比价',
        '自行招标',
        '委托招标',
        '执行框架协议',
      ],
    };
  },
  created() {
    this.routeData = this.$route.query;
  },
  mounted() {
    this.purchaseQueryDetail();
  },
  methods: {
    dealAttachmentName,
    async purchaseQueryDetail() {
      const params = {
        purchasePlanId: Number(this.routeData.purchasePlanId),
      };
      const res = await Api.purchaseQueryDetail(params);
      if (res.code == '200') {
        this.formData = res.data;
        this.tableData = res.data.purchasePlanItemVOList;

        this.queryAuditBusinessFlowLogList();
      }
    },

    // 获取审批流数据
    async queryAuditBusinessFlowLogList() {
      const { companyId } = JSON.parse(localStorage.getItem('USERINFO'));
      const params = {
        companyId,
        businessId: this.$route.query.purchasePlanId,
        businessAuditType: 4, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标
      };
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200' && res.data.length > 0) {
        const data = res.data || [];

        // 封装发起审批人数据
        const firstData = {
          step: '发起审批',
          icon: require('@/assets/img/approval/fqsp.png'),
          auditStatus: 1,
          nodeMember: {
            auditMemberPhone: '',
            auditMemberName: this.formData.createMemberName,
            approveTime: this.formData.createTime,
          },
        };

        // 封装发起审批 的数据 插入第一条
        data.unshift(firstData);
        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }
    },

    // 查看采购计划详情
    handleCodeDetail(row) {
      const { purchaseDemandId } = row;
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId },
      });
    },

    // 附件名称
    getAttachmentName(row) {
      if (row.purchaseDemandItemAttachmentDetailVOS.length) {
        return row[0].attachmentName || '';
      }
      return '';
    },

    handleLook(row) {
      if (row.purchasePlanDemandItemVOList?.length >= 2) {
        return true;
      }
      return false;
    },

    // 下载附件
    handleExportDatail(row) {
      if (row.purchaseDemandItemAttachmentDetailVOS[0].attachmentUrl) {
        utils.downFile(row[0].attachmentUrl, row[0].attachmentName);
      }
    },
    // 下载附件
    handleExportDatail2(row) {
      if (row.attachmentUrl) {
        utils.downFile(row.attachmentUrl, row.attachmentName);
      }
    },

    // 查看
    async queryPurchaseDemandPlanItem(row) {
      if (row.purchasePlanDemandItemVOList?.length) {
        this.detailTableData = row.purchasePlanDemandItemVOList;
        this.visible = true;
      }
    },

    resetPopupData() {
      this.visible = false;
    },

    // table滚动 设置最大高度
    bindMaxHeight() {
      if (this.maxHeight) {
        return { maxHeight: this.maxHeight };
      }
      return {};
    },

    // 返回上一页
    handleGoBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.approve-dialog {
  .approve-bottom {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
.steps-box {
  box-sizing: border-box;
  padding: 20px;
}
.submit-box {
  margin-top: 20px;
  display: flex;
  .btn-other {
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    color: #004898;
    background: #ffffff;
    border: 1px solid #004898;
    cursor: pointer;
    -webkit-user-select: none;
  }
}
.approve-btn {
  margin-top: 4px;
  float: right;
}
.approve-title {
  width: 30%;
  float: left;
}
.approve-box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  border: 1px solid #d9d9d9;
  height: 50px;
  line-height: 50px;
}
.header-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  width: 100%;
  margin-bottom: 10px;
  text-align: center;
}
.title-h2 {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-left: 20px;
}
.divider-title {
  margin-top: 10px;
}
.btn-th {
  border-radius: 0;
  margin-left: 10px;
}
.el-divider--horizontal {
  margin: 10px 0;
}

.dialog-footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.commodity-list {
  border: 1px solid #d9d9d9;
  margin: 10px 0;
  .title {
    color: #333;
    height: 44px;
    line-height: 44px;
    background: #f5f5f5;
    padding-left: 20px;
    border-bottom: 1px solid #d9d9d9;
    font-size: 16px;
    font-weight: bold;
  }
}

.file-name {
  margin-right: 10px;
  color: #0064c8;
  cursor: pointer;
}

::v-deep .el-tabs__content {
  padding: 0;
}
::v-deep .el-tabs__item {
  border: 1px solid #e4e7ed !important;
}
::v-deep .el-tabs__nav-prev,
::v-deep .el-tabs__nav-next {
  width: 20px;
  height: 100%;
  border-right: 1px solid #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: normal;
}
::v-deep .el-tabs__nav-next {
  border-left: 1px solid #d9d9d9;
  border-right: none;
}
::v-deep .el-tabs--border-card {
  box-shadow: none;
  border-bottom: none;
}
::v-deep .el-upload-list {
  width: 100% !important;
  display: flex;
}
::v-deep .el-upload-list__item {
  width: 20% !important;
}
::v-deep .el-table th.el-table__cell {
  background-color: #f5f5f5 !important;
}

::v-deep .el-form-item {
  margin-bottom: 0;
  .el-input__inner {
    border-radius: 0;
  }
  .el-textarea__inner {
    border-radius: 0;
  }
  .el-form-item__label {
    line-height: 32px;
    padding: 0;
  }
  .el-form-item__content {
    line-height: 32px;
  }
}
::v-deep .el-table {
  th.el-table__cell > .cell {
    font-weight: normal;
    font-size: 14px;
  }
}
</style>
